import { STORES_TYPE } from 'constants.js'

export const FETCH_COUNTRIES = 'FETCH_COUNTRIES'
export const FETCH_COUNTRIES_SUCCESS = 'FETCH_COUNTRIES_SUCCESS'
export const FETCH_COUNTRIES_ERROR = 'FETCH_COUNTRIES_ERROR'

export const FETCH_COMPLETENESS_GENERAL_REVENUE = 'FETCH_COMPLETENESS_GENERAL_REVENUE'
export const FETCH_COMPLETENESS_GENERAL_REVENUE_SUCCESS = 'FETCH_COMPLETENESS_GENERAL_REVENUE_SUCCESS'
export const FETCH_COMPLETENESS_GENERAL_REVENUE_ERROR = 'FETCH_COMPLETENESS_GENERAL_REVENUE_ERROR'

export const FETCH_DELAYED_STORES = 'FETCH_DELAYED_STORES'
export const FETCH_DELAYED_STORES_SUCCESS = 'FETCH_DELAYED_STORES_SUCCESS'
export const FETCH_DELAYED_STORES_ERROR = 'FETCH_DELAYED_STORES_ERROR'

export const DROPDOWN_OPTIONS = [
  { label: 'box.allStores', value: STORES_TYPE.ALL },
  { label: 'box.newStores', value: STORES_TYPE.NEW },
  { label: 'box.opened1yStores', value: STORES_TYPE.OPENED_1Y },
  { label: 'box.changed30dStores', value: STORES_TYPE.CHANGED_30D },
  { label: 'box.changed1yStores', value: STORES_TYPE.CHANGED_1Y },
  { label: 'box.floorSpaceDecreased1yOnly', value: STORES_TYPE.FLOOR_SPACE_DECREASED1Y_ONLY },
  { label: 'box.floorSpaceDecreased30dOnly', value: STORES_TYPE.FLOOR_SPACE_DECREASED30D_ONLY },
  { label: 'box.floorSpaceIncreased1yOnly', value: STORES_TYPE.FLOOR_SPACE_INCREASED1Y_ONLY },
  { label: 'box.floorSpaceIncreased30dOnly', value: STORES_TYPE.FLOOR_SPACE_INCREASED30D_ONLY },
]
